import { Link } from 'react-router-dom';

export default function Landing() {
  return (
    <div className="landing">
      <div className="landing-hero-banner">
        <img src="/images/landing-hero.jpg" alt="" />
        <div className="landing-hero-overlay">
          <h1>How ready is your business for AI?</h1>
        </div>
      </div>

      <div className="page">
        <p className="lede">
          The Technology &amp; AI Readiness Scorecard is a 25-question diagnostic that shows you
          where your business stands today — and where to focus next.
        </p>

        <ul className="landing-bullets">
          <li><strong>Takes less than 10 minutes.</strong> One question at a time. No fluff.</li>
          <li><strong>Six dimensions.</strong> From software spend to AI governance.</li>
          <li><strong>A score and a plan.</strong> See your maturity tier, your biggest gaps, and two quick wins you can start this week.</li>
        </ul>

        <div className="nav-row">
          <span className="muted small">No account required.</span>
          <Link to="/scorecard/ai-readiness"><button>See your score</button></Link>
        </div>
      </div>
    </div>
  );
}
